var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.227,
    height: 7.227,
    viewBox: "0 0 7.227 7.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x38_",
    transform: "translate(-5.82 -5.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_7_",
    d: "M13.047,11.935l-2.5-2.5,2.5-2.5L11.935,5.821l-2.5,2.5-2.5-2.5L5.821,6.932l2.5,2.5-2.5,2.5,1.112,1.112,2.5-2.5,2.5,2.5Z",
    fill: "#5b5b5b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6dd5f077e5574da0e895032d223436b8.svg";
export { ForwardRef as ReactComponent };